var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.729 1.00195H2.80975C1.70518 1.00195 0.809753 1.89738 0.809753 3.00195V8.99813C0.809753 10.1027 1.70519 10.9981 2.80975 10.9981H5.18436H12.729C13.8335 10.9981 14.729 10.1027 14.729 8.99813V3.00195C14.729 1.89738 13.8335 1.00195 12.729 1.00195Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.583099 2.57886L6.19442 6.82985C7.27898 7.65149 8.7807 7.64033 9.85292 6.80265L15.2594 2.57886",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5a0425f0a6a850a7e42c8e193a96e297.svg";
export { ForwardRef as ReactComponent };